import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import MainNavbar from '../MainNavbar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faHeart, faTrashAlt, faEye } from '@fortawesome/free-solid-svg-icons';
import './Profile.css';
import { useNavigate } from 'react-router-dom';
import { FaEnvelope, FaPhoneAlt } from 'react-icons/fa';
import { FaUserAlt, FaInfoCircle, FaEdit, FaUserSecret, FaHeart } from 'react-icons/fa';
import { FaCalendarAlt } from 'react-icons/fa';
import { IoIosShareAlt } from 'react-icons/io'; // 👈 new icon
import { MdPrint } from 'react-icons/md';
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import { GiCancel, GiPencil } from 'react-icons/gi';
import { useContext } from "react";
import AlertContext from "../../../contexts/AlertContext";

const Profile = () => {
    const { userId } = useParams(); // Access userId from route params
    const [currentUser, setCurrentUser] = useState({ userId: '', gender: '', name: '' });
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [profiles, setProfiles] = useState([]);
    const { showAlert } = useContext(AlertContext);
    const [isOpen, setIsOpen] = useState(false);
    const [basicDetails, setBasicDetails] = useState({});
    const [personalDetails, setPersonalDetails] = useState({});
    const [partnerPreferences, setPartnerPreferences] = useState({});
    const [accountCreationDate, setAccountCreationDate] = useState('');
    const [acceptedCount, setAcceptedCount] = useState(0);
    const [followingCount, setFollowingCount] = useState(0);
    const [deactivationType, setDeactivationType] = useState('temporary');
    const [duration, setDuration] = useState(1); // default 1 month
    const [errorMessage, setErrorMessage] = useState('');
    const [isDeactivated, setIsDeactivated] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const [activeList, setActiveList] = useState(null); // 'followers' | 'following' | null
    const [acceptedProfiles, setAcceptedProfiles] = useState([]);
    const [followingProfiles, setFollowingProfiles] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [planInfo, setPlanInfo] = useState(null);
    const [error, setError] = useState('');
    const [shortlistedUsers, setShortlistedUsers] = useState([]);
    const [message, setMessage] = useState('');
    const navigate = useNavigate();
    const [form, setForm] = useState({
        basic: {},
        religious: {},
        professional: {},
        location: {},
        aboutMyPartner: ''
    });
    const fileInputRef = useRef(null);

    const handleEditClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };
    const [editing, setEditing] = useState(false);
    const [saving, setSaving] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [formData, setFormData] = useState(personalDetails); // clone from props or context
    const [basicEditMode, setBasicEditMode] = useState(false);
    const [basicForm, setBasicForm] = useState({
        name: basicDetails?.basicDetails?.name || '',
        aboutMe: basicDetails?.basicDetails?.aboutMe || '',
        age: basicDetails?.basicDetails?.age || '',
        qualification: basicDetails?.basicDetails?.qualification || '',
        profilePicture: basicDetails?.basicDetails?.profilePicture || '',
        phoneNumber: basicDetails?.basicDetails?.phoneNumber || '',
    });
    const [previewPic, setPreviewPic] = useState(basicForm.profilePicture || '');
    const [customUserId, setCustomUserId] = useState('');

    const toggleSelect = (userId) => {
        setSelectedUsers(prev =>
            prev.includes(userId)
                ? prev.filter(id => id !== userId)
                : [...prev, userId]
        );
    };


    const fetchShortlistedUsers = async () => {
        try {
            const response = await axios.get('https://back.varankal.com/auth/shortlisted', { withCredentials: true });
            console.log('Shortlisted Users:', response.data);
            setShortlistedUsers(response.data);
        } catch (error) {
            console.error('Error fetching shortlisted users:', error.response ? error.response.data : error.message);
            setError('Error fetching shortlisted users');
        }
    };

    // Call fetchShortlistedUsers when component mounts
    useEffect(() => {
        fetchShortlistedUsers(); // Fetch shortlisted users
    }, [currentUser.userId]);

    const unshortlistUser = async (userId) => {
        const confirmed = window.confirm("Are you sure you want to remove this user from your shortlist?");
        if (!confirmed) return;

        try {
            const response = await axios.post(
                `https://back.varankal.com/auth/unshortlist/${userId}`,
                { currentUserId: currentUser._id || currentUser.userId },
                { withCredentials: true }
            );
            console.log('✅ Unshortlisted:', response.data);

            // Remove from shortlist immediately in UI
            setShortlistedUsers(prev => prev.filter(u => u._id !== userId && u.userId !== userId));

            // Also update selectedUsers so trash button disappears
            setSelectedUsers(prev => prev.filter(id => id !== userId));

        } catch (error) {
            console.error('❌ Error unshortlisting user:', error);
        }
    };

    const toggleDropdown = () => {
        setShowDropdown((prev) => !prev);
    };

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) return;

        axios
            .get('https://back.varankal.com/app/userreports/profile-view-usage', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                withCredentials: true,
            })
            .then((res) => {
                setPlanInfo(res.data);
            })
            .catch((err) => {
                setError('Unable to fetch plan details.');
                console.error(err);
            });
    }, []);


    // ✅ Check Token Exist Or Not (Redirect If No Token)
    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            // ✅ If no token, redirect to login page
            navigate('/profile');
        }
    }, [navigate]);

    useEffect(() => {
        // ✅ Add background class to the body
        document.body.classList.add('body-background');

        // ✅ Remove background class on component unmount
        return () => {
            document.body.classList.remove('body-background');
        };
    }, []);

    const handleProfileClick = async (userId) => {
        try {
            const response = await axios.get(`https://back.varankal.com/user/view-profile/${userId}`, { withCredentials: true });

            // ✅ Proceed if access is granted
            if (response.data.profile) {
                navigate(`/userpage/${userId}`);
            }
        } catch (error) {
            // ⛔ Show alert or notification if access denied
            if (error.response && error.response.status === 403) {
                alert(error.response.data.error || "Upgrade your plan to view more profiles.");
            } else {
                showAlert("An error occurred while accessing the profile.");
            }
        }
    };


    useEffect(() => {
        const fetchBasicDetails = async () => {
            try {
                const response = await axios.get(`https://back.varankal.com/user/currentregister-details/${userId}`, { withCredentials: true });
                setBasicDetails(response.data); // ✅ This includes both userId and basicDetails
            } catch (error) {
                console.error('Error fetching user data', error);
            }
        };

        const fetchPersonalDetails = async () => {
            try {
                const response = await axios.get(`https://back.varankal.com/user/currentpersonal-details/${userId}`, { withCredentials: true });
                setPersonalDetails(response.data);

                const createdAt = new Date(response.data.createdAt);
                const month = createdAt.toLocaleString('default', { month: 'long' });
                const year = createdAt.getFullYear();

                setAccountCreationDate(`${month} ${year}`);
            } catch (error) {
                console.error('Error fetching personal details:', error);
            }
        };

        const fetchPartnerPreferences = async () => {
            try {
                const response = await axios.get(
                    `https://back.varankal.com/user/currentpartnerpreferences/${userId}`,
                    { withCredentials: true }
                );
                const data = response.data;
                setPartnerPreferences(data);
                setForm({
                    basic: data.basic || {},
                    religious: data.religious || {},
                    professional: data.professional || {},
                    location: data.location || {},
                    aboutMyPartner: data.about?.aboutMyPartner || ''
                });
            } catch (error) {
                console.error('Error fetching partner preferences:', error);
            }
        };


        const fetchCustomUserId = async () => {
            try {
                const response = await axios.get(
                    'https://back.varankal.com/auth/fetch-custom-id',
                    { withCredentials: true }
                );

                setCustomUserId(response.data.customUserId);
            } catch (error) {
                console.error('Error fetching custom user ID:', error);
            }
        };


        // Call functions to fetch data
        fetchBasicDetails();
        fetchPersonalDetails();
        fetchPartnerPreferences();
        fetchCustomUserId();
    }, [userId]);



    const fetchAcceptedCount = async () => {
        try {
            const response = await axios.get('https://back.varankal.com/user/accepted-count', {
                withCredentials: true, // important for cookie-based auth
            });

            console.log("Accepted count response:", response.data);
            setAcceptedCount(response.data.acceptedCount); // ✅ make sure you are setting it correctly
        } catch (error) {
            console.error("Error fetching accepted count:", error);
        }
    };

    const fetchFollowingCount = async () => {
        try {
            const response = await axios.get('https://back.varankal.com/user/following-count', {
                withCredentials: true // to include the cookie for authentication
            });

            console.log('Following count:', response.data);
            setFollowingCount(response.data.followingCount);
        } catch (error) {
            console.error('Error fetching following count:', error);
        }
    };

    const fetchAcceptedProfiles = async () => {
        try {
            const response = await axios.get('https://back.varankal.com/user/accepted-profiles', {
                withCredentials: true, // important for cookie-based auth
            });

            console.log("Accepted profiles response:", response.data);
            setAcceptedProfiles(response.data.followers); // ✅ setFollowers list (adjust your state name accordingly)
        } catch (error) {
            console.error("Error fetching accepted profiles:", error);
        }
    };

    const fetchFollowingProfiles = async () => {
        try {
            const response = await axios.get('https://back.varankal.com/user/following-profiles', {
                withCredentials: true
            });

            console.log("Following profiles response:", response.data);
            setFollowingProfiles(response.data.following); // ✅ setFollowingProfiles list
        } catch (error) {
            console.error("Error fetching following profiles:", error);
        }
    };


    useEffect(() => {
        fetchAcceptedCount();
        fetchFollowingCount();
        fetchAcceptedProfiles();
        fetchFollowingProfiles();
    }, []);


    const handleLogout = async () => {
        try {
            const response = await axios.post(
                'https://back.varankal.com/auth/logout',
                {},
                { withCredentials: true }
            );

            if (response.status === 200) {
                console.log(response.data.message); // Logout successful

                // ✅ Clear token and user info from localStorage
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                setIsLoggedIn(false); // <- important to trigger re-render

                // ✅ Redirect to login or home page
                navigate('/');
            } else {
                console.error('Logout failed.');
            }
        } catch (error) {
            console.error('Logout error:', error.response?.data?.message || error.message);
        }
    };

    const handleDeactivation = async () => {
        try {
            if (deactivationType === 'temporary') {
                if (!duration || parseInt(duration) < 1) {
                    showAlert('Please provide a valid duration (in months)', "error");
                    return;
                }

                const confirmTemp = window.confirm(
                    `Are you sure you want to temporarily deactivate your account for ${duration} month(s)?`
                );
                if (!confirmTemp) return;

            } else if (deactivationType === 'permanent') {
                const confirmPermanent = window.confirm(
                    '⚠️ This will permanently delete your account. Continue?'
                );
                if (!confirmPermanent) return;
            }

            const payload = {
                type: deactivationType,
                durationInMonths: deactivationType === 'temporary' ? duration : undefined,
            };

            // 1. Deactivate account
            await axios.post('https://back.varankal.com/auth/deactivate', payload, {
                withCredentials: true,
            });

            showAlert('Account deactivated successfully.');
            setShowDropdown(false);

            // ✅ 2. Call your handleLogout logic
            await handleLogout(); // this includes localStorage cleanup + redirect

        } catch (error) {
            console.error('Error during deactivation:', error);
            alert(error.response?.data?.message || 'An error occurred while deactivating your account.');
        }
    };

    // const handleReactivate = async () => {
    //     try {
    //         const res = await axios.post('https://back.varankal.com/auth/reactivate', {}, {
    //             withCredentials: true
    //         });
    //         alert(res.data.message);
    //         // Maybe refresh user data or redirect
    //     } catch (error) {
    //         alert(error.response.data.message || 'Something went wrong');
    //     }
    // };

    useEffect(() => {
        if (basicDetails?.basicDetails) {
            setBasicForm({
                name: basicDetails.basicDetails.name || '',
                aboutMe: basicDetails.basicDetails.aboutMe || '',
                age: basicDetails.basicDetails.age || '',
                qualification: basicDetails.basicDetails.qualification || '',
                profilePicture: basicDetails.basicDetails.profilePicture || '',
                phoneNumber: basicDetails.basicDetails.phoneNumber || '',
            });
            setPreviewPic(basicDetails.basicDetails.profilePicture || '');
        }
    }, [basicDetails]);

    const handleSaveBasic = async () => {
        try {
            const payload = {
                name: basicForm.name,
                aboutMe: basicForm.aboutMe,
                age: basicForm.age,
                qualification: basicForm.qualification,
                profilePicture: basicForm.profilePicture,
                phoneNumber: basicForm.phoneNumber,
            };
            const res = await axios.put(
                'https://back.varankal.com/user/update-basic-details',
                payload,
                { withCredentials: true }
            );
            setBasicDetails(res.data);
            setBasicEditMode(false);
            showAlert('Basic details updated successfully! ❤');
        } catch (err) {
            console.error('Failed to update basic details:', err);
        }
    };

    const handleProfilePicChange = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onloadend = () => {
            const base64 = reader.result.split(',')[1]; // strip prefix
            setBasicForm(f => ({ ...f, profilePicture: base64 }));
            setPreviewPic(base64);
        };
        reader.readAsDataURL(file);
    };

    const handleCancelBasic = () => {
        if (basicDetails?.basicDetails) {
            setBasicForm({
                name: basicDetails.basicDetails.name || '',
                aboutMe: basicDetails.basicDetails.aboutMe || '',
                age: basicDetails.basicDetails.age || '',
                qualification: basicDetails.basicDetails.qualification || '',
                profilePicture: basicDetails.basicDetails.profilePicture || '',
                phoneNumber: basicDetails.basicDetails.phoneNumber || '',
            });
            setPreviewPic(basicDetails.basicDetails.profilePicture || '');
        }
        setBasicEditMode(false);
    };

    const handlePersonalSave = async () => {
        setSaving(true);
        try {
            const payload = {
                personalDetails: formData
            };

            const res = await axios.post(
                'https://back.varankal.com/user/update-details',
                payload,
                { withCredentials: true }
            );

            setPersonalDetails(res.data.data);
            setFormData(res.data.data);
            setEditMode(false);


            showAlert('Personal details updated successfully! ❤️');
        } catch (err) {
            console.error('Personal details save failed', err);
            toast.error('Failed to save details 💔');
            showAlert('Failed to save details 💔');
        } finally {
            setSaving(false);
        }
    };

    const handleChange = (section, field, value) => {
        if (section === 'about') {
            setForm(f => ({ ...f, aboutMyPartner: value }));
        } else {
            setForm(f => ({
                ...f,
                [section]: { ...f[section], [field]: value }
            }));
        }
    };

    const handleSave = async () => {
        setSaving(true);
        try {
            const payload = {
                preferences: {
                    basic: form.basic,
                    religious: form.religious,
                    professional: form.professional,
                    location: form.location,
                    aboutMyPartner: form.aboutMyPartner
                }
            };
            const res = await axios.put(
                'https://back.varankal.com/user/partner-preference',
                payload,
                { withCredentials: true }
            );
            setPartnerPreferences(res.data);
            setForm({
                basic: res.data.basic || {},
                religious: res.data.religious || {},
                professional: res.data.professional || {},
                location: res.data.location || {},
                aboutMyPartner: res.data.about?.aboutMyPartner || ''
            });
            setEditing(false);

            // ✅ Success message with emoji 🎉✨
            showAlert('Partner preferences updated successfully! ✨🎉');

        } catch (err) {
            console.error('Save failed', err);

            // ❌ Error toast with emoji ⚠️💥
            toast.error('Failed to save partner preferences 💥');
        } finally {
            setSaving(false);
        }
    };
    const handleCancel = () => {
        setForm({
            basic: partnerPreferences.basic || {},
            religious: partnerPreferences.religious || {},
            professional: partnerPreferences.professional || {},
            location: partnerPreferences.location || {},
            aboutMyPartner: partnerPreferences.about?.aboutMyPartner || ''
        });
        setEditing(false);
    };



    const handleShare = () => {
        const profileUrl = `https://varankal.com/profile`;

        if (navigator.share) {
            navigator
                .share({
                    title: 'Matrimony Profile',
                    text: 'Check out this profile on Matrimony Platform!',
                    url: profileUrl,
                })
                .then(() => console.log('Profile shared successfully'))
                .catch((error) => console.error('Sharing failed', error));
        } else {
            // Fallback for desktop browsers
            navigator.clipboard.writeText(profileUrl);
            showAlert('Profile link copied to clipboard!');
        }
    };

    const handlePrint = () => {
        if (!basicDetails) {
            console.error('Profile data is not available yet.');
            return; // Prevent print if profile is not available
        }

        const printContent = document.getElementById('profile-details'); // Get the profile section
        if (!printContent) {
            console.error('Profile details not found');
            return;
        }

        const newWindow = window.open('', '', 'width=600,height=400'); // Open a new window for printing
        newWindow.document.write('<html><head><title>Print Profile</title></head><body>');
        newWindow.document.write(printContent.innerHTML); // Copy profile content to new window
        newWindow.document.write('</body></html>');
        newWindow.document.close(); // Close the document
        newWindow.print(); // Trigger the print dialog
    };
    // useEffect(() => {
    //     const fetchProfiles = async () => {
    //         try {
    //             // Hitting the correct backend route based on your setup
    //             const res = await axios.get('https://back.varankal.com/auth/suggested-profiles', {
    //                 withCredentials: true, // Ensures token in cookies is sent
    //             });

    //             if (res.data.message) {
    //                 setMessage(res.data.message);
    //             } else {
    //                 setProfiles(res.data);
    //             }
    //         } catch (err) {
    //             console.error('Error fetching profiles:', err);
    //             setMessage('Error fetching profiles');
    //         }
    //     };

    //     fetchProfiles();
    // }, []);
    // useEffect(() => {
    //     const container = document.querySelector('.profiles-scroll-container');
    //     const onWheel = (e) => {
    //         if (e.deltaY === 0) return;
    //         e.preventDefault();
    //         container.scrollLeft += e.deltaY;
    //     };
    //     container.addEventListener('wheel', onWheel);
    //     return () => container.removeEventListener('wheel', onWheel);
    // }, []);


    return (
        <>
            <MainNavbar />
            <div id="profile-details" className="containerww89">

                <div className="profile-headerww">
                    <div className="profile-picww">
                        {previewPic ? (
                            <img
                                src={`data:image/jpeg;base64,${previewPic}`}
                                alt="Profile"
                                className="profile-imageww"
                            />
                        ) : (
                            <div className="placeholderww">No Profile Picture</div>
                        )}
                        {basicEditMode && (
                            <div className="image-edit-container-5566">
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={handleProfilePicChange}
                                    ref={fileInputRef}
                                    className="file-input-hidden-5566"
                                />
                                <button onClick={handleEditClick} className="edit-button-5566">
                                    <FaEdit className="edit-icon-5566" />
                                </button>
                            </div>
                        )}

                        <div className='sharetoprofile'>
                            <button onClick={handleShare} className="share-icon-btn" title="Share Profile">
                                <IoIosShareAlt size={20} />
                            </button>
                            <button onClick={handlePrint} className="share-icon-btnnt" title="Print Profile">
                                <MdPrint size={20} color="black" />
                            </button>
                        </div>
                    </div>


                    <div className="profile-infoww">
                        <div className="profile-header">
                            <div className="user-info">
                                <span className="user-name">{basicDetails?.basicDetails?.name || 'User Name'}</span>
                                {/*<span className="user-id">({basicDetails?.userId || 'N/A'})</span>*/}
                                <span className="user-id">({customUserId || 'N/A'})</span>

                            </div>
                            <span
                                className="account-settings"
                                title="Account Settings"
                                onClick={() => setShowDropdown(true)}
                            >
                                &#8942;
                            </span>
                        </div>
                    </div>

                    {showDropdown && (
                        <>
                            <div className="overlayLR" onClick={() => setShowDropdown(false)}></div>
                            <div className="modalContentLR" onClick={(e) => e.stopPropagation()}>
                                <div className="modalHeaderLR">
                                    <h2>Deactivate Account</h2>
                                    <span className="closeIconLR" onClick={() => setShowDropdown(false)}>✖</span>
                                </div>

                                <div className="optionSectionLR">
                                    <label className="checkboxOptionLR">
                                        <input
                                            type="checkbox"
                                            checked={deactivationType === 'temporary'}
                                            onChange={() =>
                                                setDeactivationType(prev => prev === 'temporary' ? '' : 'temporary')
                                            }
                                        />
                                        Temporarily Hide My Profile
                                    </label>

                                    {deactivationType === 'temporary' && (
                                        <div className="durationInputLR">
                                            <label>
                                                Duration (months):
                                                <input
                                                    type="number"
                                                    min="1"
                                                    value={duration}
                                                    onChange={(e) => setDuration(e.target.value)}
                                                />
                                            </label>
                                        </div>
                                    )}

                                    <label className="checkboxOptionLR">
                                        <input
                                            type="checkbox"
                                            checked={deactivationType === 'permanent'}
                                            onChange={() =>
                                                setDeactivationType(prev => prev === 'permanent' ? '' : 'permanent')
                                            }
                                        />
                                        Permanently Delete My Account
                                    </label>
                                </div>

                                {errorMessage && <p className="errorLR">{errorMessage}</p>}

                                <div className="modalActionsLR">
                                    <button onClick={handleDeactivation}>Confirm Deactivation</button>
                                </div>
                            </div>
                        </>
                    )}

                    <div className='profilebasicfff'>
                        <p>
                            <span className="label">Age</span>
                            <span className="colon">:</span>
                            <span className="value">
                                {basicDetails?.basicDetails?.age ? `${basicDetails.basicDetails.age} Yrs` : 'N/A'}
                            </span>
                        </p>

                        <p><span className="label">Occupation</span><span className="colon">:</span><span className="value">{personalDetails.occupation || 'N/A'}</span></p>

                        <p><span className="label">Height</span><span className="colon">:</span><span className="value">{personalDetails.height ? `${personalDetails.height} Cm` : 'N/A'}</span></p>

                        <p><span className="label">Religion/Caste</span><span className="colon">:</span><span className="value">{personalDetails.religion && personalDetails.caste ? `${personalDetails.religion}/${personalDetails.caste}` : 'N/A'}</span></p>


                        <p>
                            <span className="label">Qualification</span>
                            <span className="colon">:</span>
                            <span className="value">
                                {basicDetails?.basicDetails?.qualification || 'N/A'}
                            </span>
                        </p>

                        <p><span className="label">Location</span><span className="colon">:</span><span className="value">{personalDetails.location?.district || 'N/A'}</span></p>
                    </div>

                </div>

                <div className="profile-stats">
                    <div className="followers-box" onClick={() => setActiveList('')} style={{ cursor: 'pointer' }}>
                        <h5>Accepted: <span className="stat-number">{acceptedCount}</span></h5>
                    </div>
                    <div className="following-box" onClick={() => setActiveList('')} style={{ cursor: 'pointer' }}>
                        <h5>Requested: <span className="stat-number">{followingCount}</span></h5>
                    </div>

                    <div className="shortlist-dropdown-ADD4">
                        <div className="shortlisted-box-ADD5" onClick={() => setIsOpen()} title="Shortlisted">
                            <h5 className="shortlisted-title-ADD5">
                                Shortlisted: <span className="shortlisted-count-ADD5">{shortlistedUsers.length}</span>
                            </h5>
                        </div>

                        {isOpen && (
                            <div className="shortlist-popup-overlay-ADD4">
                                <div className="shortlist-popup-content-ADD4">
                                    <div className="shortlist-popup-header56">
                                        <h3>Shortlists</h3>
                                        <button onClick={() => setIsOpen(false)} className="popup-close-btn56">×</button>
                                    </div>

                                    {/* Search Bar */}
                                    <div className="shortlist-search-container-ADD4">
                                        <input
                                            type="text"
                                            placeholder="Search"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            className="shortlist-search-bar-ADD4"
                                        />
                                    </div>

                                    {shortlistedUsers.length === 0 ? (
                                        <p className="shortlist-empty-ADD4">No users shortlisted yet.</p>
                                    ) : (
                                        shortlistedUsers
                                            .filter(user => {

                                                return user.name?.toLowerCase().includes(searchQuery.toLowerCase());
                                            })
                                            .map(user => (
                                                <div
                                                    key={user._id}
                                                    className="shortlist-user-item-ADD4"
                                                    onClick={() => handleProfileClick(user._id)}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <div className="shortlist-user-info-ADD4" onClick={(e) => e.stopPropagation()}>
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedUsers.includes(user._id)}
                                                            onChange={() => toggleSelect(user._id)}
                                                        />
                                                        <img
                                                            src={`data:image/jpeg;base64,${user.profilePicture}`}
                                                            alt="Profile"
                                                            width={25}
                                                            height={25}
                                                            style={{ borderRadius: '50%', marginLeft: '8px', marginRight: '8px' }}
                                                        />
                                                        <span className="single-line-name">
                                                            {user.name} - {user.age ? `${user.age}` : 'N/A'}
                                                        </span>

                                                    </div>

                                                    <div className="shortlist-actions-inline-ADD4" onClick={(e) => e.stopPropagation()}>
                                                        {selectedUsers.includes(user._id) && (
                                                            <button
                                                                onClick={() => {
                                                                    console.log("Removing from shortlist:", user);
                                                                    const idToSend = user._id || user.userId;
                                                                    if (!idToSend) {
                                                                        console.error("❌ No valid ID found for this user");
                                                                        return;
                                                                    }
                                                                    unshortlistUser(idToSend);
                                                                }}
                                                                className="remove-btn-ADD4"
                                                            >
                                                                <FontAwesomeIcon
                                                                    icon={faTrashAlt}
                                                                    style={{ marginRight: '5px', fontSize: '15px', color: 'black' }}
                                                                />
                                                            </button>

                                                        )}
                                                    </div>

                                                </div>

                                            ))
                                    )}
                                </div>
                            </div>
                        )}

                    </div>

                </div>


                {activeList === 'followers' && (
                    <div className="overlay-container">
                        <div className="overlay-background" onClick={() => setActiveList(null)} />

                        <div className="followers-panel">
                            <button className="close-icon" onClick={() => setActiveList(null)}>×</button>
                            <h4>Accepted List</h4>

                            {/* 🔍 Search Bar */}
                            <input
                                type="text"
                                placeholder="Search"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                style={{
                                    width: '100%',
                                    padding: '8px',
                                    marginBottom: '10px',
                                    border: '1px solid #ccc',
                                    borderRadius: '5px',
                                    marginTop: '30px',
                                }}
                            />

                            {acceptedProfiles.length === 0 ? (
                                <p>No Accepted found.</p>
                            ) : (
                                <ul>
                                    {acceptedProfiles
                                        .filter(profile =>
                                            profile.name?.toLowerCase().includes(searchQuery.toLowerCase())
                                        )
                                        .map((profile, index) => (
                                            <li
                                                key={index}
                                                onClick={() => handleProfileClick(profile._id)}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    marginBottom: '10px',
                                                    cursor: 'pointer',
                                                    marginTop: '25px',
                                                    padding: '5px',
                                                    borderRadius: '5px',
                                                    transition: 'background 0.2s',
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.background = '#f0f0f0'}
                                                onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                                            >
                                                <img
                                                    src={`data:image/jpeg;base64,${profile.profilePicture}`}
                                                    alt={`${profile.name}'s profile`}
                                                    style={{ width: '40px', height: '40px', borderRadius: '50%', marginRight: '10px' }}
                                                />
                                                <span style={{ flex: 1 }}>
                                                    {profile.name} {profile.age ? `- ${profile.age}` : ''}
                                                </span>

                                            </li>
                                        ))}
                                </ul>
                            )}
                        </div>
                    </div>
                )}


                {activeList === 'following' && (
                    <div className="overlay-container">
                        <div className="overlay-background" onClick={() => setActiveList(null)} />

                        <div className="following-panel">
                            <button className="close-icon" onClick={() => setActiveList(null)}>×</button>
                            <h4>Requested List</h4>
                            <input
                                type="text"
                                placeholder="Search"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                style={{
                                    width: '100%',
                                    padding: '8px',
                                    marginBottom: '10px',
                                    border: '1px solid #ccc',
                                    borderRadius: '5px',
                                    marginTop: '30px',
                                }}
                            />

                            {followingProfiles.length === 0 ? (
                                <p>No Requested found.</p>
                            ) : (
                                <ul>
                                    {followingProfiles
                                        .filter(profile =>
                                            profile.name?.toLowerCase().includes(searchQuery.toLowerCase())
                                        )
                                        .map((profile, index) => (
                                            <li
                                                key={index}
                                                onClick={() => handleProfileClick(profile._id)}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    marginBottom: '10px',
                                                    marginTop: '25px',
                                                    cursor: 'pointer',
                                                    padding: '5px',
                                                    borderRadius: '5px',
                                                    transition: 'background 0.2s',
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.background = '#f0f0f0'}
                                                onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                                            >
                                                <img
                                                    src={`data:image/jpeg;base64,${profile.profilePicture}`}
                                                    alt={`${profile.name}'s profile`}
                                                    style={{ width: '40px', height: '40px', borderRadius: '50%', marginRight: '10px' }}
                                                />
                                                <span style={{ flex: 1 }}>
                                                    {profile.name} {profile.age ? `- ${profile.age}` : ''}
                                                </span>

                                            </li>
                                        ))}
                                </ul>
                            )}
                        </div>
                    </div>
                )}


                {/* <button onClick={handleReactivate}>
                    Reactivate My Account
                </button> */}




                <div className="emailphonenumbererer">
                    {/* <label className="contact-label">Contact</label> */}

                    <div className="info-lineer">
                        <FaEnvelope className="icononer" />
                        <span>
                            {basicDetails?.basicDetails?.email || 'N/A'}
                        </span>
                    </div>

                    <div className="vertical-lineer"></div> {/* Vertical line */}

                    <div className="info-lineer">
                        <FaPhoneAlt className="icononer" />
                        <span>
                            {basicDetails?.basicDetails?.phoneNumber || 'N/A'}
                        </span>
                    </div>


                </div>
                {/* Remove Upgrade CTA if not needed */}
                {/* <div className="upgrade-now-container">
        <span className="upgrade-link" onClick={() => navigate('/subscription')}>
            Upgrade Now
        </span>
        <span className="view-details"> to view details</span>
    </div> */}

                <div className="plan-container">
                    {planInfo ? (
                        <div className="plan-inline">
                            <p><strong>Plan Name:</strong> {planInfo.plan}</p>
                            <p><strong>Views Used:</strong> {planInfo.viewsUsed} / {planInfo.viewsUsed + planInfo.viewsLeft}</p>
                        </div>
                    ) : (
                        <p>Loading plan details...</p>
                    )}
                </div>


                <p className="date5678">
                    <FaCalendarAlt className="iconon96" style={{ marginRight: '6px' }} />
                    {accountCreationDate}
                </p>
                <hr className='devifrdskds'></hr>

                {/* <h2 className="suggestion-title">Suggested Profiles Nearby Your Location</h2>
                <div className="profiles-scroll-container">
                    <div className="profiles-row">
                        {profiles.map((profile, idx) => (
                            <div key={idx} className="profile-box-77">
                                <div className="profile-image-wrapper-77">
                                    <img
                                        src={`data:image/jpeg;base64,${profile.profilePicture}`}
                                        alt="Profile"
                                        className="profile-img-77"
                                    />
                                </div>
                                <div className="profile-details-77">
                                    <h4 className="profile-name-77">{profile.name}, {profile.age}</h4>
                                    <p className="profile-location-77">{profile.location}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div> */}

                <div className="profile-sectionsww">

                    <div className="sectionww">
                        <h3>
                            <FaUserAlt style={{ marginRight: '8px', marginBottom: '-3px' }} /> About Me
                        </h3>

                        <div className="edit-button-containerww">
                            {basicEditMode ? (
                                <>
                                    <button className="edit-buttonww" onClick={handleSaveBasic} title="Save">
                                        <FontAwesomeIcon icon={faCheck} className="edit-iconww" />
                                    </button>
                                    <button
                                        className="edit-buttonww ml-2"
                                        onClick={handleCancelBasic}
                                        title="Cancel"
                                    >
                                        <FontAwesomeIcon icon={faXmark} className="edit-iconww" />
                                    </button>
                                </>
                            ) : (
                                <button
                                    className="edit-buttonww"
                                    onClick={() => setBasicEditMode(true)}
                                    title="Edit"
                                >
                                    <FontAwesomeIcon icon={faPenToSquare} className="edit-iconww" />
                                </button>
                            )}
                        </div>
                        {basicEditMode ? (
                            <textarea
                                className="highlight2-edit"
                                value={basicForm.aboutMe}
                                onChange={e => setBasicForm(f => ({ ...f, aboutMe: e.target.value }))}
                                placeholder="Tell something about yourself..."
                                rows={4}
                            />
                        ) : (
                            <p className="abouttyyy">{basicDetails?.basicDetails?.aboutMe || 'N/A'}</p>
                        )}


                        <h3>
                            <FaInfoCircle style={{ marginRight: '8px', marginBottom: '-3px' }} /> Basic Details
                        </h3>

                        <div className="details-gridww">
                            <table className="details-table67ww">
                                <tbody>
                                    <tr>
                                        <td><strong>Name</strong></td>
                                        <td>
                                            {basicEditMode ? (
                                                <input
                                                    className="highlight2-edit"
                                                    type="text"
                                                    value={basicForm.name}
                                                    onChange={e => setBasicForm(f => ({ ...f, name: e.target.value }))}
                                                    placeholder="Add Name"
                                                />
                                            ) : (
                                                basicDetails?.basicDetails?.name || 'Add Name'
                                            )}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td><strong>Age</strong></td>
                                        <td>
                                            {basicEditMode ? (
                                                <input
                                                    className="highlight2-edit"
                                                    type="number"
                                                    value={basicForm.age}
                                                    onChange={e => setBasicForm(f => ({ ...f, age: e.target.value }))}
                                                    placeholder="Add Age"
                                                />
                                            ) : (
                                                basicDetails?.basicDetails?.age || 'Add Age'
                                            )}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td><strong>Weight / Height</strong></td>
                                        <td>
                                            {editMode ? (
                                                <>
                                                    <input
                                                        type="text"
                                                        className="highlight2-edit"
                                                        value={formData?.weight || ''}
                                                        onChange={e =>
                                                            setFormData(f => ({ ...f, weight: e.target.value }))
                                                        }
                                                        placeholder="Add Weight"
                                                        style={{ width: '80px', marginRight: '10px' }}
                                                    />
                                                    /
                                                    <input
                                                        type="text"
                                                        className="highlight2-edit"
                                                        value={formData?.height || ''}
                                                        onChange={e =>
                                                            setFormData(f => ({ ...f, height: e.target.value }))
                                                        }
                                                        placeholder="Add Height"
                                                        style={{ width: '80px', marginLeft: '10px' }}
                                                    />
                                                </>
                                            ) : (
                                                <>
                                                    {personalDetails?.weight || 'Add Weight'} / {personalDetails?.height || 'Add Height'}
                                                </>
                                            )}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td><strong>Qualification</strong></td>
                                        <td>
                                            {basicEditMode ? (
                                                <input
                                                    className="highlight2-edit"
                                                    type="text"
                                                    value={basicForm.qualification}
                                                    onChange={e => setBasicForm(f => ({ ...f, qualification: e.target.value }))}
                                                    placeholder="Add Qualification"
                                                />
                                            ) : (
                                                basicDetails?.basicDetails?.qualification || 'Add Qualification'
                                            )}
                                        </td>
                                    </tr>


                                    <tr>
                                        <td><strong>Occupation</strong></td>
                                        <td>
                                            {editMode ? (
                                                <input
                                                    type="text"
                                                    className="highlight2-edit"
                                                    value={formData?.occupation || ''}
                                                    onChange={e =>
                                                        setFormData(f => ({ ...f, occupation: e.target.value }))
                                                    }
                                                    placeholder="Add Occupation"
                                                />
                                            ) : (
                                                personalDetails?.occupation || "Add Occupation"
                                            )}
                                        </td>
                                    </tr>



                                </tbody>
                            </table>

                            {/* Right Table */}
                            <table className="details-table67ww">
                                <tbody>
                                    <tr>
                                        <td><strong>Annual Income</strong></td>
                                        <td>
                                            {editMode ? (
                                                <input
                                                    type="text"
                                                    className="highlight2-edit"
                                                    value={formData?.userIncome || ''}
                                                    onChange={e =>
                                                        setFormData(f => ({ ...f, userIncome: e.target.value }))
                                                    }
                                                    placeholder="Add User Income"
                                                />
                                            ) : (
                                                personalDetails?.userIncome || 'Add User Income'
                                            )}
                                        </td>
                                    </tr>



                                    <tr>
                                        <td><strong>Religion</strong></td>
                                        <td>
                                            {editMode ? (
                                                <input
                                                    type="text"
                                                    className="highlight2-edit"
                                                    value={formData?.religion || ''}
                                                    onChange={e =>
                                                        setFormData(f => ({ ...f, religion: e.target.value }))
                                                    }
                                                    placeholder="Enter Religion"
                                                />
                                            ) : (
                                                personalDetails?.religion || 'Not provided'
                                            )}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td><strong>Caste</strong></td>
                                        <td>
                                            {editMode ? (
                                                <input
                                                    type="text"
                                                    className="highlight2-edit"
                                                    value={formData?.caste || ''}
                                                    onChange={e =>
                                                        setFormData(f => ({ ...f, caste: e.target.value }))
                                                    }
                                                    placeholder="Enter Caste"
                                                />
                                            ) : (
                                                personalDetails?.caste || 'Not provided'
                                            )}
                                        </td>
                                    </tr>


                                    <tr>
                                        <td><strong>Location</strong></td>
                                        <td>
                                            {editMode ? (
                                                <>
                                                    <input
                                                        type="text"
                                                        className="highlight2-edit"
                                                        value={formData?.location?.state || ''}
                                                        onChange={e =>
                                                            setFormData(f => ({
                                                                ...f,
                                                                location: {
                                                                    ...f.location,
                                                                    state: e.target.value
                                                                }
                                                            }))
                                                        }
                                                        placeholder="State"
                                                        style={{ width: '100px', marginRight: '10px' }}
                                                    />
                                                    ,
                                                    <input
                                                        type="text"
                                                        className="highlight2-edit"
                                                        value={formData?.location?.district || ''}
                                                        onChange={e =>
                                                            setFormData(f => ({
                                                                ...f,
                                                                location: {
                                                                    ...f.location,
                                                                    district: e.target.value
                                                                }
                                                            }))
                                                        }
                                                        placeholder="District"
                                                        style={{ width: '100px', marginLeft: '10px' }}
                                                    />
                                                </>
                                            ) : (
                                                personalDetails?.location
                                                    ? `${personalDetails.location.state || 'State'}, ${personalDetails.location.district || 'District'}`
                                                    : 'Location'
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><strong>Mobile Number</strong></td>
                                        <td>
                                            {basicEditMode ? (
                                                <input
                                                    className="highlight2-edit"
                                                    type="text"
                                                    value={basicForm.phoneNumber}
                                                    onChange={e => setBasicForm(f => ({ ...f, phoneNumber: e.target.value }))}
                                                    placeholder="Add Mobile Number"
                                                />
                                            ) : (
                                                basicDetails?.basicDetails?.phoneNumber || 'Add Mobile Number'
                                            )}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>


                    <div className="sectionww">
                        <h3><FaUserSecret style={{ marginRight: '8px', marginBottom: '-3px' }} /> Personal Details</h3>
                        <div className="edit-button-containerww">
                            {editMode ? (
                                <>
                                    <button
                                        className="edit-buttonww"
                                        onClick={handlePersonalSave}
                                        disabled={saving}
                                        title="Save"
                                    >
                                        <FontAwesomeIcon icon={faCheck} className="edit-iconww" />
                                    </button>
                                    <button
                                        className="edit-buttonww ml-2"
                                        onClick={() => {
                                            setEditMode(false);
                                            setFormData(personalDetails); // discard unsaved edits
                                        }}
                                        disabled={saving}
                                        title="Cancel"
                                    >
                                        <FontAwesomeIcon icon={faXmark} className="edit-iconww" />
                                    </button>
                                </>
                            ) : (
                                <button
                                    className="edit-buttonww"
                                    onClick={() => setEditMode(true)}
                                    title="Edit"
                                >
                                    <FontAwesomeIcon icon={faPenToSquare} className="edit-iconww" />
                                </button>
                            )}

                        </div>

                        <div className="details-gridww">
                            {/* Left Table */}
                            <table className="details-tableww">
                                <tbody>
                                    <tr>
                                        <td><strong>Father's Name</strong></td>
                                        <td>
                                            {editMode ? (
                                                <input
                                                    className="highlight2-edit"
                                                    value={formData?.fatherName || ''}
                                                    onChange={e =>
                                                        setFormData(f => ({ ...f, fatherName: e.target.value }))
                                                    }
                                                    placeholder="Add Father's Name"
                                                />
                                            ) : (
                                                personalDetails?.fatherName || "Add Father's Name"
                                            )}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td><strong>Father's Occupation</strong></td>
                                        <td>
                                            {editMode ? (
                                                <input
                                                    className="highlight2-edit"
                                                    value={formData?.fatherOccupation || ''}
                                                    onChange={e =>
                                                        setFormData(f => ({ ...f, fatherOccupation: e.target.value }))
                                                    }
                                                    placeholder="Add Father's Occupation"
                                                />
                                            ) : (
                                                personalDetails?.fatherOccupation || "Add Father's Occupation"
                                            )}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td><strong>Mother's Name</strong></td>
                                        <td>
                                            {editMode ? (
                                                <input
                                                    className="highlight2-edit"
                                                    value={formData?.motherName || ''}
                                                    onChange={e =>
                                                        setFormData(f => ({ ...f, motherName: e.target.value }))
                                                    }
                                                    placeholder="Add Mother's Name"
                                                />
                                            ) : (
                                                personalDetails?.motherName || "Add Mother's Name"
                                            )}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td><strong>Mother's Occupation</strong></td>
                                        <td>
                                            {editMode ? (
                                                <input
                                                    className="highlight2-edit"
                                                    value={formData?.motherOccupation || ''}
                                                    onChange={e =>
                                                        setFormData(f => ({ ...f, motherOccupation: e.target.value }))
                                                    }
                                                    placeholder="Add Mother's Occupation"
                                                />
                                            ) : (
                                                personalDetails?.motherOccupation || "Add Mother's Occupation"
                                            )}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td><strong>Number of Siblings</strong></td>
                                        <td>
                                            {editMode ? (
                                                <input
                                                    className="highlight2-edit"
                                                    value={formData?.noOfSiblings || ''}
                                                    onChange={e =>
                                                        setFormData(f => ({ ...f, noOfSiblings: e.target.value }))
                                                    }
                                                    placeholder="Nill"
                                                />
                                            ) : (
                                                personalDetails?.noOfSiblings || "Nill"
                                            )}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td><strong>Family Class</strong></td>
                                        <td>
                                            {editMode ? (
                                                <input
                                                    className="highlight2-edit"
                                                    value={formData?.familyClass || ''}
                                                    onChange={e =>
                                                        setFormData(f => ({ ...f, familyClass: e.target.value }))
                                                    }
                                                    placeholder="Add Family Class"
                                                />
                                            ) : (
                                                personalDetails?.familyClass || "Add Family Class"
                                            )}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td><strong>Family Value</strong></td>
                                        <td>
                                            {editMode ? (
                                                <input
                                                    className="highlight2-edit"
                                                    value={formData?.familyOrientation || ''}
                                                    onChange={e =>
                                                        setFormData(f => ({ ...f, familyOrientation: e.target.value }))
                                                    }
                                                    placeholder="Add Family Value"
                                                />
                                            ) : (
                                                personalDetails?.familyOrientation || "Add Family Value"
                                            )}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            {/* Right Table */}
                            <table className="details-tableww">
                                <tbody>
                                    <tr>
                                        <td><strong>Number of Brothers</strong></td>
                                        <td>
                                            {editMode ? (
                                                <input
                                                    className="highlight2-edit"
                                                    value={formData?.noOfBrothers || ''}
                                                    onChange={e =>
                                                        setFormData(f => ({ ...f, noOfBrothers: e.target.value }))
                                                    }
                                                    placeholder="Nill"
                                                />
                                            ) : (
                                                personalDetails?.noOfBrothers || "Nill"
                                            )}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td><strong>Number of Sisters</strong></td>
                                        <td>
                                            {editMode ? (
                                                <input
                                                    className="highlight2-edit"
                                                    value={formData?.noOfSisters || ''}
                                                    onChange={e =>
                                                        setFormData(f => ({ ...f, noOfSisters: e.target.value }))
                                                    }
                                                    placeholder="Nill"
                                                />
                                            ) : (
                                                personalDetails?.noOfSisters || "Nill"
                                            )}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td><strong>Complexion</strong></td>
                                        <td>
                                            {editMode ? (
                                                <input
                                                    className="highlight2-edit"
                                                    value={formData?.complexion || ''}
                                                    onChange={e =>
                                                        setFormData(f => ({ ...f, complexion: e.target.value }))
                                                    }
                                                    placeholder="Add Complexion"
                                                />
                                            ) : (
                                                personalDetails?.complexion || "Add Complexion"
                                            )}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td><strong>Hobbies</strong></td>
                                        <td>
                                            {editMode ? (
                                                <input
                                                    className="highlight2-edit"
                                                    value={formData?.hobbies || ''}
                                                    onChange={e =>
                                                        setFormData(f => ({ ...f, hobbies: e.target.value }))
                                                    }
                                                    placeholder="Add Hobbies"
                                                />
                                            ) : (
                                                personalDetails?.hobbies || "Add Hobbies"
                                            )}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td><strong>Interest</strong></td>
                                        <td>
                                            {editMode ? (
                                                <input
                                                    className="highlight2-edit"
                                                    value={formData?.interest || ''}
                                                    onChange={e =>
                                                        setFormData(f => ({ ...f, interest: e.target.value }))
                                                    }
                                                    placeholder="Add Interest"
                                                />
                                            ) : (
                                                personalDetails?.interest || "Add Interest"
                                            )}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td><strong>Drinking Habits</strong></td>
                                        <td>
                                            {editMode ? (
                                                <input
                                                    className="highlight2-edit"
                                                    value={formData?.drinkingHabits || ''}
                                                    onChange={e =>
                                                        setFormData(f => ({ ...f, drinkingHabits: e.target.value }))
                                                    }
                                                    placeholder="Add Drinking Habits"
                                                />
                                            ) : (
                                                personalDetails?.drinkingHabits || "Add Drinking Habits"
                                            )}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td><strong>Smoking Habits</strong></td>
                                        <td>
                                            {editMode ? (
                                                <input
                                                    className="highlight2-edit"
                                                    value={formData?.smokingHabits || ''}
                                                    onChange={e =>
                                                        setFormData(f => ({ ...f, smokingHabits: e.target.value }))
                                                    }
                                                    placeholder="Add Smoking Habits"
                                                />
                                            ) : (
                                                personalDetails?.smokingHabits || "Add Smoking Habits"
                                            )}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>


                    </div>


                    <div className="sectionww">
                        <div className="flex justify-between items-start">
                            <h3>
                                <FaHeart style={{ marginRight: '8px', marginBottom: '-3px' }} /> Partner Preferences
                            </h3>
                            <div className="edit-button-containerww">
                                {editing ? (
                                    <>
                                        <button
                                            className="edit-buttonww"
                                            onClick={handleSave}
                                            disabled={saving}
                                            title="Save"
                                        >
                                            <FontAwesomeIcon icon={faCheck} className="edit-iconww" />
                                        </button>
                                        <button
                                            className="edit-buttonww ml-2"
                                            onClick={handleCancel}
                                            disabled={saving}
                                            title="Cancel"
                                        >
                                            <FontAwesomeIcon icon={faXmark} className="edit-iconww" />
                                        </button>
                                    </>
                                ) : (
                                    <button
                                        className="edit-buttonww"
                                        onClick={() => setEditing(true)}
                                        title="Edit"
                                    >
                                        <FontAwesomeIcon icon={faPenToSquare} className="edit-iconww" />
                                    </button>
                                )}
                            </div>
                        </div>

                        <div className="preferences-sectionww">
                            <h4>About Partner</h4>
                            {editing ? (
                                <textarea
                                    className="highlight2-edit"
                                    value={form.aboutMyPartner}
                                    onChange={e => handleChange('about', null, e.target.value)}
                                    placeholder="Tell us about your partner"
                                />
                            ) : (
                                <p className="about-partnerrww">
                                    {partnerPreferences.about?.aboutMyPartner || 'Tell us about your partner'}
                                </p>
                            )}

                            <div className="preferences-gridww">
                                <div className="preferences-leftww">
                                    <h4>Partner Preferences</h4>
                                    <table className="preferences-tableww">
                                        <tbody>
                                            <tr>
                                                <td><strong>Age Range</strong></td>
                                                <td>
                                                    {editing ? (
                                                        <>
                                                            <input
                                                                style={{ width: '55px' }}
                                                                placeholder="min"
                                                                className="highlight2-edit"
                                                                value={form.basic.ageRange?.min || ''}
                                                                onChange={e =>
                                                                    setForm(f => ({
                                                                        ...f,
                                                                        basic: {
                                                                            ...f.basic,
                                                                            ageRange: { ...(f.basic.ageRange || {}), min: e.target.value }
                                                                        }
                                                                    }))
                                                                }
                                                            />{' '}
                                                            -{' '}
                                                            <input
                                                                style={{ width: '55px' }}
                                                                placeholder="max"
                                                                className="highlight2-edit"
                                                                value={form.basic.ageRange?.max || ''}
                                                                onChange={e =>
                                                                    setForm(f => ({
                                                                        ...f,
                                                                        basic: {
                                                                            ...f.basic,
                                                                            ageRange: { ...(f.basic.ageRange || {}), max: e.target.value }
                                                                        }
                                                                    }))
                                                                }
                                                            />
                                                        </>
                                                    ) : (
                                                        `${partnerPreferences.basic?.ageRange?.min || 'min'} - ${partnerPreferences.basic?.ageRange?.max || 'max'}`
                                                    )}
                                                </td>
                                            </tr>
                                            {[
                                                { key: 'height', label: 'Height' },
                                                { key: 'motherTongue', label: 'Mother Tongue' },
                                                { key: 'maritalStatus', label: 'Marital Status' },
                                                { key: 'eatingHabits', label: 'Eating Habits' },
                                                { key: 'drinkingHabits', label: 'Drinking Habits' },
                                                { key: 'smokingHabits', label: 'Smoking Habits' }
                                            ].map(({ key, label }) => (
                                                <tr key={key}>
                                                    <td><strong>{label}</strong></td>
                                                    <td>
                                                        {editing ? (
                                                            <input
                                                                className="highlight2-edit"
                                                                value={form.basic?.[key] || ''}
                                                                onChange={e =>
                                                                    setForm(f => ({
                                                                        ...f,
                                                                        basic: { ...f.basic, [key]: e.target.value }
                                                                    }))
                                                                }
                                                                placeholder={`Add ${label}`}
                                                            />
                                                        ) : (
                                                            partnerPreferences.basic?.[key] || `Add ${label}`
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}

                                            <tr>
                                                <td><strong>Qualification</strong></td>
                                                <td>
                                                    {editing ? (
                                                        <input
                                                            className="highlight2-edit"
                                                            value={form.professional?.education || ''}
                                                            onChange={e =>
                                                                setForm(f => ({
                                                                    ...f,
                                                                    professional: { ...f.professional, education: e.target.value }
                                                                }))
                                                            }
                                                            placeholder="Add Qualification"
                                                        />
                                                    ) : (
                                                        partnerPreferences.professional?.education || 'Add Qualification'
                                                    )}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><strong>Profession</strong></td>
                                                <td>
                                                    {editing ? (
                                                        <input
                                                            className="highlight2-edit"
                                                            value={form.professional?.employedIn || ''}
                                                            onChange={e =>
                                                                setForm(f => ({
                                                                    ...f,
                                                                    professional: { ...f.professional, employedIn: e.target.value }
                                                                }))
                                                            }
                                                            placeholder="Add Profession"
                                                        />
                                                    ) : (
                                                        partnerPreferences.professional?.employedIn || 'Add Profession'
                                                    )}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><strong>Income</strong></td>
                                                <td>
                                                    {editing ? (
                                                        <input
                                                            className="highlight2-edit"
                                                            value={form.professional?.annualIncome || ''}
                                                            onChange={e =>
                                                                setForm(f => ({
                                                                    ...f,
                                                                    professional: { ...f.professional, annualIncome: e.target.value }
                                                                }))
                                                            }
                                                            placeholder="Add Income"
                                                        />
                                                    ) : (
                                                        partnerPreferences.professional?.annualIncome || 'Add Income'
                                                    )}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div className="preferences-rightww">
                                    <div className="preferences-boxww">
                                        <h4>Religion Preferences</h4>
                                        <table className="preferences-tableww">
                                            <tbody>
                                                {[
                                                    { key: 'religion', label: 'Religion' },
                                                    { key: 'caste', label: 'Caste' },
                                                    { key: 'subCaste', label: 'Sub-Caste' }
                                                ].map(({ key, label }) => (
                                                    <tr key={key}>
                                                        <td><strong>{label}</strong></td>
                                                        <td>
                                                            {editing ? (
                                                                <input
                                                                    className="highlight2-edit"
                                                                    value={form.religious?.[key] || ''}
                                                                    onChange={e =>
                                                                        setForm(f => ({
                                                                            ...f,
                                                                            religious: { ...f.religious, [key]: e.target.value }
                                                                        }))
                                                                    }
                                                                    placeholder={`Add ${label}`}
                                                                />
                                                            ) : (
                                                                partnerPreferences.religious?.[key] || `Add ${label}`
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="preferences-boxww">
                                        <h4>Location Preferences</h4>
                                        <table className="preferences-tableww">
                                            <tbody>
                                                {[
                                                    { key: 'state', label: 'State' },
                                                    { key: 'district', label: 'District' }
                                                ].map(({ key, label }) => (
                                                    <tr key={key}>
                                                        <td><strong>{label}</strong></td>
                                                        <td>
                                                            {editing ? (
                                                                <input
                                                                    className="highlight2-edit"
                                                                    value={form.location?.[key] || ''}
                                                                    onChange={e =>
                                                                        setForm(f => ({
                                                                            ...f,
                                                                            location: { ...f.location, [key]: e.target.value }
                                                                        }))
                                                                    }
                                                                    placeholder={`Add ${label}`}
                                                                />
                                                            ) : (
                                                                partnerPreferences.location?.[key] || `Add ${label}`
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </>
    );
};

export default Profile;



